"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var autocompletePath = 'handlers/autocomplete.ashx';
var maxCountInResponse = 200;
var cache = {};
var addToCache = function (request, response) {
    if (response.Success) {
        var keyInCache = JSON.stringify(request);
        cache[keyInCache] = response;
    }
};
var ControllerAutocomplete = /** @class */ (function () {
    function ControllerAutocomplete(webServer) {
        this._webServer = webServer;
    }
    ControllerAutocomplete.prototype.GetCities = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var prevFilter, prevRequest, keyInCache, valueInCache, suggestionsInCache, suitableSuggestions, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (filter.patern.length > 0) {
                            prevFilter = Object.assign({}, filter);
                            do {
                                prevRequest = getFilterForCities(prevFilter);
                                keyInCache = JSON.stringify(prevRequest);
                                valueInCache = cache[keyInCache];
                                if (valueInCache !== undefined) {
                                    suggestionsInCache = valueInCache.Result || [];
                                    if (suggestionsInCache.length === 0) {
                                        // в кэше 0
                                        return [2 /*return*/, valueInCache];
                                    }
                                    if (suggestionsInCache.length < maxCountInResponse) {
                                        suitableSuggestions = GetAddressesFromPrevRequest(valueInCache, filter, false);
                                        //if (suitableSuggestions.Result.length > 0) {
                                        return [2 /*return*/, suitableSuggestions];
                                        //}
                                        // нет подходящих, нужно делать запрос
                                        // break;  
                                    }
                                    // предыдущий запрос вернул {maxCountInResponse} записей
                                    // значит на сервере еще много данных
                                    break;
                                }
                                prevFilter.patern = prevFilter.patern.substring(0, prevFilter.patern.length - 1);
                            } while (prevFilter.patern.length > 1);
                        }
                        request = getFilterForCities(filter);
                        return [4 /*yield*/, this._webServer.fetchFromDefaultPort(autocompletePath, request)];
                    case 1:
                        response = _a.sent();
                        addToCache(request, response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerAutocomplete.prototype.GetAddresses = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var prevFilter, prevRequest, keyInCache, valueInCache, suggestionsInCache, suitableSuggestions, request, customAutoCompletePath, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (filter.patern.length > 0) {
                            prevFilter = Object.assign({}, filter);
                            do {
                                prevRequest = getFilterForAddresses(prevFilter);
                                keyInCache = JSON.stringify(prevRequest);
                                valueInCache = cache[keyInCache];
                                if (valueInCache !== undefined) {
                                    suggestionsInCache = valueInCache.Result || [];
                                    if (suggestionsInCache.length === 0) {
                                        return [2 /*return*/, valueInCache];
                                    }
                                    if (suggestionsInCache.length < maxCountInResponse) {
                                        suitableSuggestions = GetAddressesFromPrevRequest(valueInCache, filter, false);
                                        return [2 /*return*/, suitableSuggestions];
                                        // нет подходящих, нужно делать запрос
                                        // break;                        
                                    }
                                    // предыдущий запрос вернул {maxCountInResponse} записей
                                    // значит на сервере еще много данных
                                    break;
                                }
                                prevFilter.patern = prevFilter.patern.substring(0, prevFilter.patern.length - 1);
                            } while (prevFilter.patern.length > 1);
                        }
                        request = getFilterForAddresses(filter);
                        customAutoCompletePath = 'https://server.sedi.ru:12013/api/AddressCache/GetAddress';
                        return [4 /*yield*/, this._webServer.fetchFromDefaultPort(customAutoCompletePath, request, true)];
                    case 1:
                        response = _a.sent();
                        addToCache(request, response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    ControllerAutocomplete.prototype.GetHouses = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var prevFilter, prevRequest, keyInCache, valueInCache, suggestionsInCache, suitableSuggestions, request, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prevFilter = Object.assign({}, filter);
                        // ! в домах prevFilter.patern.length >= 0    
                        prevFilter.patern += ' ';
                        while (prevFilter.patern.length > 0) {
                            prevFilter.patern = prevFilter.patern.substring(0, prevFilter.patern.length - 1);
                            prevRequest = getFilterForHouses(prevFilter);
                            keyInCache = JSON.stringify(prevRequest);
                            valueInCache = cache[keyInCache];
                            if (valueInCache !== undefined) {
                                suggestionsInCache = valueInCache.Result || [];
                                if (suggestionsInCache.length === 0) {
                                    return [2 /*return*/, valueInCache];
                                }
                                if (suggestionsInCache.length < maxCountInResponse
                                    // или фильтр по дому пуст
                                    || filter.patern.length === 0) {
                                    suitableSuggestions = GetAddressesFromPrevRequest(valueInCache, filter, true);
                                    if (suitableSuggestions.Result.length > 0) {
                                        return [2 /*return*/, suitableSuggestions];
                                    }
                                    // нет подходящих, нужно делать запрос
                                    // break;  
                                }
                                // предыдущий запрос вернул {maxCountInResponse} записей
                                // значит на сервере еще много данных
                                break;
                            }
                        }
                        ;
                        request = getFilterForHouses(filter);
                        return [4 /*yield*/, this._webServer.fetchFromDefaultPort(autocompletePath, request)];
                    case 1:
                        response = _a.sent();
                        addToCache(request, response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return ControllerAutocomplete;
}());
exports.ControllerAutocomplete = ControllerAutocomplete;
var getGeoFilterParams = function (filter) {
    var result = {};
    if (filter.lat !== undefined) {
        result.lat = filter.lat.toString();
    }
    if (filter.lon !== undefined) {
        result.lon = filter.lon.toString();
    }
    if (filter.radius !== undefined) {
        result.radius = filter.radius.toString();
    }
    return result;
};
var getFilterForAddresses = function (filter) {
    return __assign({ q: 'addr', city: filter.city || '', types: filter.city !== undefined ? 'street,object' : 'city,street,object', search: filter.patern }, getGeoFilterParams(filter));
};
var getFilterForHouses = function (filter) {
    return __assign({ q: 'addr', city: filter.city, streetobj: filter.street, house: filter.patern || '' }, getGeoFilterParams(filter));
};
var getFilterForCities = function (filter) {
    return __assign({ 'q': 'addr', city: filter.patern || '' }, getGeoFilterParams(filter));
};
exports.trimRightCommaAndWhitespace = function (text) {
    var regexTrimRightCommaAndWhitespace = /(.*?)([,\s])+$/gi;
    var resultValue = text.replace(regexTrimRightCommaAndWhitespace, '$1');
    return resultValue;
};
var GetAddressesFromPrevRequest = function (prevResponse, filter, startsWithHouseNumber) {
    var searchLowerCase = exports.trimRightCommaAndWhitespace(filter.patern.trimRight().toLowerCase());
    if (searchLowerCase.length === 0) {
        return prevResponse;
    }
    // immutable
    var copyResponse = Object.assign({}, prevResponse);
    if (startsWithHouseNumber) {
        // подсказки с домами вида 'имя улица, номер_дома'
        copyResponse.Result = copyResponse.Result
            .filter(function (a) { return a.v.toLowerCase().includes(' ' + searchLowerCase); });
    }
    else {
        copyResponse.Result = copyResponse.Result
            .filter(function (a) { return a.v.toLowerCase().includes(searchLowerCase); });
    }
    return copyResponse;
};
exports.autocompleteAddressComparer = function (suggestion1, suggestion2) {
    return suggestion1.t === suggestion2.t
        && suggestion1.n === suggestion2.n
        && exports.autocompleteGeoComparer(suggestion1.g, suggestion2.g)
        && suggestion1.c === suggestion2.c
        && suggestion1.v === suggestion2.v;
};
exports.autocompleteGeoComparer = function (geo1, geo2) {
    if (geo1 === geo2) {
        return true;
    }
    if (geo1 !== undefined && geo2 !== undefined) {
        return geo1.lat === geo2.lat
            && geo1.lon === geo2.lon;
    }
    return false;
};
//# sourceMappingURL=ControllerAutocomplete.js.map